import * as DocumentPicker from "expo-document-picker";
import * as ImageManipulator from 'expo-image-manipulator';
import { apiservice, BaseUrl } from "../service/api";
import * as ImagePicker from "expo-image-picker";

export function conditionMonth(params) {
  return parseInt(params) > 12 ? 12 : params;
}

export function conditionDay(params) {
  return parseInt(params) > 31 ? 31 : params;
}

export async function addImage() {
  let result = await DocumentPicker.getDocumentAsync({
    type: "application/image",
  });

  const manipulated = await ImageManipulator.manipulateAsync(
    result.uri,
    [{ resize: { width: 800 } }], // ปรับตามที่ต้องการ เช่น width = 800px
    { compress: 0.8, format: ImageManipulator.SaveFormat.PNG, base64: true }
  );

  const response = await apiservice({
    path: "/image/create",
    method: "post",
    body: {
      name: result.name,
      base64: manipulated.base64,
    },
  });

  if (response.status == 200) {
    return (
      BaseUrl +
      "/image/getimage/" +
      response.data.imageRefId
        .replace(".png", "")
        .replace(".jpg", "")
        .replace(".jpeg", "")
    );
  } else {
    return false;
  }
}

export async function addImage1() {
  let result = await ImagePicker.launchImageLibraryAsync({
    mediaTypes: ImagePicker.MediaTypeOptions.Images,
    base64: true,
  });

  const manipulated = await ImageManipulator.manipulateAsync(
    result.uri,
    [{ resize: { width: 800 } }], // ปรับตามที่ต้องการ เช่น width = 800px
    { compress: 0.8, format: ImageManipulator.SaveFormat.PNG, base64: true }
  );

  const response = await apiservice({
    path: "/image/create",
    method: "post",
    body: {
      name: new Date().getTime() + ".jpg",
      base64: manipulated.base64,
    },
  });

  if (response.status == 200) {
    return (
      BaseUrl +
      "/image/getimage/" +
      response.data.imageRefId
        .replace(".png", "")
        .replace(".jpg", "")
        .replace(".jpeg", "")
    );
  } else {
    return false;
  }
}
